/* eslint-disable tailwindcss/no-arbitrary-value */
/* eslint-disable max-len */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable @mizdra/layout-shift/require-size-attributes */

import React from 'react';
import proptypes from 'prop-types';
import {
  Card,
  CardMedia,
  CardTitle,
  CardBody,
  Typography,
  ThemeProvider
} from '@one-thd/sui-atomic-components';
import { useImpression } from '@thd-olt-component-react/impression';
import classNames from 'classnames/bind.js';
import { akamaiImageResize } from './helper';
import * as styles from './promo-visual-navigation.scss';
const { bool, number, shape } = proptypes;

export const PromoVisualNavigationCard = ({
  item = {},
  position = 1,
  lazyLoad = false,
  theme = '',
  enableFullBleed = false
}) => {
  const cx = classNames.bind(styles);

  let {
    altText, image = {}, id: itemID, link, promotionalOffer, previewImage
  } = item;

  let { url: imageUrl } = image;

  const { ref, clickID } = useImpression({
    data: {
      id: itemID,
      component: 'PromoVisualNavigation',
      name: 'PromoVisualNavigation',
      type: 'content',
      position
    }
  });

  if (previewImage) {
    let damDownloadedContentImage = previewImage?.damDownloadedContent;
    let damContentSelectorImage = previewImage?.damContentSelector?.assetData?.[0];

    if (damDownloadedContentImage?.url) {
      imageUrl = damDownloadedContentImage?.url;
    } else {
      imageUrl = damContentSelectorImage?.selectedImageUrl || imageUrl;
    }
  }

  imageUrl = akamaiImageResize(imageUrl, 328);

  const {
    badge, eyebrow, shouldShowDollar, shouldShowOff, specialOfferHeadline, specialOfferSubhead, simpleOfferHeadline, simpleOfferSubhead, cents, wasPrice
  } = promotionalOffer || {};

  const badgeImageURL = badge?.damContentSelector?.assetData?.[0]?.selectedImageUrl || badge?.damDownloadedContent?.url || '';

  const badgeSection = (
    <img src={badgeImageURL} alt={badge?.title} />
  );

  const eyebrowSection = (
    <CardTitle subheader={(<Typography variant="h5" height="tight" weight="display">{eyebrow}</Typography>)} />
  );

  const dollarSection = (
    <Typography variant="h5" height="tight" weight="display"><sup className="sui-align-super sui-mr-[0.13rem] sui-text-lg sui-top-[0.1rem]">$</sup></Typography>
  );

  const centsSection = (
    <span className="sui-font-bold  sui-leading-tight sui-align-super"><sup className="sui-text-xs lg:sui-text-base sui-align-super sui-top-[-0.3rem]">{cents}</sup></span>
  );

  const offSection = (
    <Typography variant="h5" height="tight" weight="display"><sub className="sui-ml-[0.4rem] sui-text-lg sui-bottom-auto">Off</sub></Typography>
  );

  const wasPriceSection = (
    <span className="sui-mb-3 lg:sui-mb-1 sui-text-xs lg:sui-text-base lg:sui-leading-tight sui-leading-normal sui-font-bold">
      Was <span className="sui-line-through">${wasPrice}</span>
    </span>
  );

  const titleSection = (
    <>
      {simpleOfferHeadline
        ? (
          <CardTitle
            header={(
              <Typography
                variant="h3"
                weight="bold"
                height="tight"
              >{simpleOfferHeadline}
              </Typography>
            )}
          />
        )
        : (
          <>
            {eyebrow && eyebrowSection}
            {badgeImageURL && <span className="lg:sui-hidden sui-block sui-w-6 sui-h-6">{badgeSection}</span>}
            {wasPrice && wasPriceSection}
            <div className="sui-flex sui-items-center">
              {badgeImageURL && <div className="sui-hidden lg:sui-block sui-w-10 sui-h-10 sui-mr-1">{badgeSection}</div>}
              {shouldShowDollar && dollarSection}
              <CardTitle header={<Typography variant="h2" weight="display" height="tight">{specialOfferHeadline}</Typography>} />
              {cents && centsSection}
              {shouldShowOff && offSection}
            </div>
          </>
        )}
    </>
  );

  const subTitleSection = (
    <>
      {simpleOfferSubhead
        ? <CardBody><Typography height="normal">{simpleOfferSubhead}</Typography></CardBody>
        : <CardBody><Typography height="normal">{specialOfferSubhead}</Typography></CardBody>}
    </>
  );

  altText = altText || simpleOfferSubhead || specialOfferSubhead;

  const paperProps = enableFullBleed ? { variant: 'shadow', shadow: 'none' } : {};
  const cardTextClass = classNames('sui-flex-row sui-grow', { 'sui-px-4 sui-pb-4': enableFullBleed });

  return (
    <ThemeProvider theme={theme}>
      <div
        ref={ref}
        /* eslint-disable-next-line react/no-unknown-property */
        clickid={clickID}
        key={`card-position-${position}`}
        className="sui-flex sui-w-full"
      >
        <Card
          key={itemID}
          target="_blank"
          href={link}
          rel="noreferrer"
          className={cx('sui-w-full sui-grid link--hover-no-underline hover:sui-shadow-lg')}
          disablePadding={enableFullBleed}
          PaperProps={paperProps}
        >
          <CardMedia
            alt={altText}
            title={altText}
            src={imageUrl}
            aspect="square"
            loading={lazyLoad ? 'lazy' : ''}
            data-contentful-entry-id={itemID}
            data-contentful-field-id="previewImage"
          />
          <div
            className={cardTextClass}
            data-contentful-entry-id={itemID}
            data-contentful-field-id="promotionalOffer"
          >
            {titleSection}
            {subTitleSection}
          </div>
        </Card>
      </div>
    </ThemeProvider>
  );
};

const displayName = 'PromoVisualNavigationCard';

const propTypes = {
  item: shape({}),
  position: number,
  lazyLoad: bool,
  theme: bool,
  enableFullBleed: bool
};

PromoVisualNavigationCard.displayName = displayName;
PromoVisualNavigationCard.propTypes = propTypes;
